import { useNavigate } from 'react-router-dom';

export default function HeroSection() {
  const navigate = useNavigate();

  return (
    <section className="relative w-full min-h-screen flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Editorial%20flat%20lay%20photography%20of%20fashion%20accessories%20sneakers%20hoodies%20and%20bags%20arranged%20on%20warm%20terracotta%20textured%20surface%20with%20dried%20palm%20leaves%20and%20ceramics%2C%20diffused%20sunlight%20from%20large%20window%2C%20soft%20cream%20and%20sand%20tones%2C%20Mediterranean%20aesthetic%2C%20minimal%20luxury%20composition%2C%20high%20end%20catalog%20style&width=1800&height=1200&seq=hero-bg-v2-2026jul&orientation=landscape"
          alt="Hipobuy Spreadsheet product collection"
          className="w-full h-full object-cover object-top"
          title="Hipobuy Spreadsheet Product Collection"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-background-50/50 via-background-50/30 to-background-50/70"></div>
      </div>

      <div className="relative z-10 w-full px-6 md:px-10 pt-20">
        <div className="flex flex-col lg:flex-row items-start lg:items-center gap-10 lg:gap-0">
          <div className="w-full lg:w-3/5">
            <div className="font-heading font-extrabold text-foreground-800 leading-none tracking-tight">
              <span className="block text-[clamp(2.5rem,6vw,7rem)]">Hipobuy</span>
              <span className="block text-[clamp(2.5rem,6vw,7rem)]">Spreadsheet</span>
              <span className="block text-[clamp(2.5rem,6vw,7rem)]">Guide</span>
            </div>
          </div>

          <div className="w-full lg:w-2/5 flex flex-col items-start lg:items-start gap-6 lg:pl-8 lg:pt-8">
            <p className="text-foreground-600 text-base md:text-lg leading-relaxed max-w-sm font-light">
              Discover curated product spreadsheets, organized finds, and expert shopping guides — all in one place.
            </p>
            <div className="flex flex-col sm:flex-row gap-3">
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="inline-flex items-center gap-2 px-6 py-3 rounded-full text-sm font-semibold border-2 border-primary-500 text-primary-600 hover:bg-primary-500 hover:text-background-50 transition-all duration-200 whitespace-nowrap cursor-pointer"
              >
                Buy It Now
                <i className="ri-arrow-right-up-line w-4 h-4 flex items-center justify-center"></i>
              </a>
              <button
                onClick={() => {
                  navigate('/hipobuy-spreadsheet-guide');
                  window.scrollTo({ top: 0, behavior: 'smooth' });
                }}
                className="inline-flex items-center gap-2 px-6 py-3 rounded-full text-sm font-semibold bg-primary-500 text-background-50 hover:bg-primary-600 transition-all duration-200 whitespace-nowrap cursor-pointer"
              >
                Read the Guide
                <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
              </button>
            </div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2 z-10 animate-bounce">
        <span className="text-xs text-foreground-400 font-medium">Scroll to explore</span>
        <i className="ri-arrow-down-line text-foreground-400 w-4 h-4 flex items-center justify-center"></i>
      </div>
    </section>
  );
}